import { render, staticRenderFns } from "./instructions-sheet.vue?vue&type=template&id=09d54a03&scoped=true&"
import script from "./instructions-sheet.vue?vue&type=script&lang=js&"
export * from "./instructions-sheet.vue?vue&type=script&lang=js&"
import style0 from "./instructions-sheet.vue?vue&type=style&index=0&id=09d54a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d54a03",
  null
  
)

export default component.exports